<div class="alert-container {{type}}"
    *ngIf="!isDismissed"
    [ngClass]="{'no-border': noBorder}" [attr.role]="!isSnackbar ? this.role : null">
  <div class="content">
    <div class="icon-container" *ngIf="showIcon">
      <mat-icon class="icon" [svgIcon]="iconTypes[type]" aria-hidden="true"></mat-icon>
    </div>
    <div class="message" [ngClass]="{'message-container': noBorder}">
      <span *ngIf="messageLabel">{{ messageLabel }}</span>
      <div *ngIf="messageSubLabel" class="normal-text text-nm">
        <span>{{ messageSubLabel }}</span>
      </div>
      <ng-content *ngIf="!messageLabel"></ng-content>
    </div>
  </div>
  <button *ngIf="dismissible"
          type="button"
          mat-icon-button
          class="dismiss-button"
          aria-label="Dismiss"
          i18n-aria-label
          (click)="onDismiss()">
    <mat-icon svgIcon="close" aria-hidden="true"></mat-icon>
  </button>
</div>
